import React, { useState, useEffect } from 'react'
import api from '../../../../Services/api';
import axios from 'axios';
import { Bar } from 'react-chartjs-2';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import LcrReport from '../../Client/vendorCompliance/lcrReport';
import ChartDataLabels from 'chartjs-plugin-datalabels';  
import MonthlyReport from '../../../../Component/MonthlyReport';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import MonthlyComplianceReport  from '../../Client/vendorCompliance/MonthlyComplianceReport';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    ArcElement
    } from 'chart.js';

    ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, ArcElement,ChartDataLabels);
    const months = [
        { name: "JANUARY", value: "01" },
        { name: "FEBRUARY", value: "02" },
        { name: "MARCH", value: "03" },
        { name: "APRIL", value: "04" },
        { name: "MAY", value: "05" },
        { name: "JUNE", value: "06" },
        { name: "JULY", value: "07" },
        { name: "AUGUST", value: "08" },
        { name: "SEPTEMBER", value: "09" },
        { name: "OCTOBER", value: "10" },
        { name: "NOVEMBER", value: "11" },
        { name: "DECEMBER", value: "12" }
    ];

const MonthlyCompliance = () => {
    let data1 = sessionStorage.getItem('user');
    let corporateData = JSON.parse(data1);
    let id = corporateData.id;


    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);
    const [vendorOptions, setVendorOptions] = useState([]);
     const [loading, setLoading] = useState(true);
     
    const [clients, setClients] = useState([]);
    const[selectedClient,setSelectedClient] = useState('');
    const[selectedClientForReport,setSelectedClientForReport] = useState('');
    const [isClientSelectedForReport,setIsclientSelectedForReport] = useState(false)
    const[selectedVendor, setSelectedVendor] = useState('');
    const[selectedMonth,setSelectedMonth] = useState('');
    const[selectedClientForAudit,setSelectedClientForAudit] = useState('')
    const[selectedVendorForAudit,setSelectedVendorForAudit] = useState('')
    const[selectedMonthForAudit,setSelectedMonthForAudit] = useState('');
    const[selectedYearForAudit,setSelecYearForAudit] = useState('');
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const[selectedClientForComplianceReport,setSelectedClientForCompliancereport] = useState('')
    const [selectedYearForReport, setSelectedYearForReport] = useState('');
        const [selectedQuarter, setSelectedQuarter] = useState('');
        const [snackbarOpen, setSnackbarOpen] = useState(false);
          const [snackbarMessage, setSnackbarMessage] = useState('');
          const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
          const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
          const [openDialog, setOpenDialog] = useState(false);
          const [openDialogForAudit, setOpenDialogForAudit] = useState(false);
          const [openDialogComplianceReport, setOpenDialogComplianceReport] = useState(false);
    const [showModal, setShowModal] = useState(false);


          
    const handleShow = () => {
        if (selectedMonthForAudit && selectedYearForAudit && selectedVendorForAudit && selectedClientForAudit) {
            setOpenDialogForAudit(false); 
            setTimeout(() => {
                setShowModal(true); 
              }, 300);
          } else {
           setErrorSnackbarOpen(true);
           setSnackbarErrorMessage('Please select required fields to view report')
          }
        };
    

const handleClose = () => {
    setShowModal(false); 
    setSelectedMonthForAudit('');
    setSelecYearForAudit('');
    setOpenDialogForAudit(false);
    
    document.body.style.overflow = 'auto';

  };

  


          const handleMonthChange = (event) => {
            setSelectedMonth(event.target.value);
        };
        const handleMonthChangeForAudit = (event) => {
            setSelectedMonthForAudit(event.target.value);
        };

   
          const handleOpenDialog = () => {
            setOpenDialog(true);
          };
        
          const handleCloseDialog = () => {
            setOpenDialog(false);
            setSelectedClientForReport('')
            setIsclientSelectedForReport(false)
            
          };

          
          const handleOpenDialogForAudit = () => {
            setOpenDialogForAudit(true);
          };
        
          const handleCloseDialogForAudit = () => {
            setOpenDialogForAudit(false);
            setSelectedVendorForAudit('')
            setSelectedClientForAudit('')
            setSelectedMonthForAudit('')
            setSelecYearForAudit('')
            
          };


          const handleOpenDialogComplianceReport = () => {
            setOpenDialogComplianceReport(true);
          };
        
          const handleCloseDialogComplianceReport = () => {
            setOpenDialogComplianceReport(false);

            setSelectedClientForCompliancereport('')
            setSelectedYearForReport('');
            setSelectedMonth('')
          };
        
  const [chartData, setChartData] = useState({
        labels: [],
        datasets: [
        {
            label: 'Accepted',
            data: [],
            backgroundColor: '#50c878',
        },
        {
            label: 'Rejected',
            data: [],
            backgroundColor: '#B22222',
        },
        {
            label: 'UnderReview',
            data: [],
            backgroundColor: '#EFCC00',
        }
        ]
    });


     useEffect(() => {
            if (snackbarMessage) {
                setSnackbarOpen(true); 
            } else {
                setSnackbarOpen(false);  
            }
        }, [snackbarMessage]); 
        
        useEffect(() => {
            if (snackbarErrorMessage) {
                setErrorSnackbarOpen(true);  
            } else {
                setErrorSnackbarOpen(false); 
            }
        }, [snackbarErrorMessage]); 

        
    const handleQuarterChange = (e) => {
        setSelectedQuarter(e.target.value);
    };
    
  
    useEffect(()=>{
        api.Corporate.getClientByCorporateId(id)
        .then(response => {
            if(response.status === 200){
          setClients(response.data.data);
       
        
            }
            else if(response.status === 404){
                setErrorSnackbarOpen(true)
                setSnackbarErrorMessage(response.data.message)
            }
            else if(response.status === 505){
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message)
            }
            else{
                setErrorSnackbarOpen(true)
                setSnackbarErrorMessage('Some error occured, Please tyr again')
            }
        
        })
        
        .catch(error => {
          console.error(`Error fetching Corporate Names`,error)
        })
        },[])

     
  
  
    const handleClientChange = (event) =>{
        const {value} = event.target;
        setSelectedClient(value);
        setSelectedVendor('');
      
            }

            
    const handleClientChangeForAudit = (event) =>{
        const {value} = event.target;
        setSelectedClientForAudit(value);
        setSelectedVendorForAudit('');
      
            }
            const handleVendorChangeForAudit = (event) =>{
                const {value} = event.target;
                setSelectedVendorForAudit(value);
                sessionStorage.setItem('selectedVendorId',value)
                
                    }

                            
    const handleClientChangeForComplianceReport = (event) =>{
        const {value} = event.target;
        setSelectedClientForCompliancereport(value);
        sessionStorage.setItem('selectedClientId',value)
        setSelectedMonth('');
        setSelectedYearForReport('')
      
            }
          



            const handleClientChangeForReport = (event) =>{
                const {value} = event.target;
                setSelectedClientForReport(value);
                setIsclientSelectedForReport(true);
               sessionStorage.setItem('selectedClientId',value)
              
                    }


            const handleVendorChange = (event) =>{
                const {value} = event.target;
                setSelectedVendor(value);
                sessionStorage.setItem('selectedVendorId',value)
                
                    }



    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };
    const handleYearChangeForAudit = (event) => {
        setSelecYearForAudit(event.target.value);
    };
    const handleYearChanges = (event) => {
        setSelectedYearForReport(event.target.value);
    };
    const getQuarterMonths = (quarter) => {
        switch (quarter) {
        case 'Q1':
            return [0, 1, 2];
        case 'Q2':
            return [3, 4, 5]; 
        case 'Q3':
            return [6, 7, 8]; 
        case 'Q4':
            return [9, 10, 11]; 
        default:
            return [];
        }
    };


    useEffect(() => {
        const fetchVendors = async () => {
            const clientId = selectedClient || selectedClientForAudit;
    
            if (!clientId) return; 
    
            try {
                const response = await api.client.getAllVendors(clientId);
    
                if(response.status === 200){
                    setVendorOptions(response.data.data.vendorProfile);
                    }
                    else if(response.status === 404)
                    {
                        setErrorSnackbarOpen(true)
                        setSnackbarErrorMessage(response.data.message);
                        setVendorOptions([])
                    }
                    else if(response.status === 400){
                        setErrorSnackbarOpen(true);
                        setSnackbarErrorMessage(response.data.message)
                        setVendorOptions([])
                    }
                    else{
                        setErrorSnackbarOpen(true);
                        setSnackbarErrorMessage("Unable to fetch details, please try again")
            }
         } catch (error) {
                console.error("Error in fetching the data", error);
            }
        
    
    
    }

    fetchVendors();
},[selectedClient,selectedClientForAudit]
);
    



  
  
  

        


      useEffect(() => {
        if (selectedVendor) {
          fetchVendorMonthlyData(selectedVendor, selectedYear, selectedQuarter,selectedClient);
        }
      }, [selectedVendor, selectedYear, selectedQuarter]);
   
  
      const fetchVendorMonthlyData = async (vendorId, year, quarter = '') => {
        try {
        const response = await axios.get(`https://www.grcpulse.in/api/monthlydata/yearly/${vendorId}`, {
            params: { year }
        });
       if(response.status === 200){
        const data = response.data.data;
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
       
        const quarterMonths = quarter ? getQuarterMonths(quarter) : [...Array(12).keys()];

        const acceptedPercent = [];
        const rejectedPercent = [];
        const underReviewPercent = [];
        const monthLabels = [];
 
        quarterMonths.forEach((monthIndex) => {
            const monthData = data.find(item => item.month === (monthIndex + 1).toString().padStart(2, '0'));
            monthLabels.push(months[monthIndex]);
            if (monthData) {
            acceptedPercent.push(monthData.AcceptedPercent || 0);
            rejectedPercent.push(monthData.RejectedPercent || 0);
            underReviewPercent.push(monthData.UnderReviewPercent || 0);
            } else {
            acceptedPercent.push(0);
            rejectedPercent.push(0);
            underReviewPercent.push(0);
            }
        });

        setChartData({
            labels: monthLabels,
            datasets: [
            {
                label: 'Accepted',
                data: acceptedPercent,
                backgroundColor: '#50c878',
                 barThickness: 12,
            },
            {
                label: 'Rejected',
                data: rejectedPercent,
                backgroundColor: '#B22222',
                 barThickness: 12,
            },
            {
                label: 'UnderReview',
                data: underReviewPercent,
                backgroundColor: '#EFCC00',
                 barThickness: 12,
            }
            ]
        });
        } 
        else if(response.status === 404)
            {
           setErrorSnackbarOpen(true);
           setSnackbarErrorMessage(response.data.message)
            }
            else if(response.status === 400){
                setErrorSnackbarOpen(true);
           setSnackbarErrorMessage(response.data.message)
            }
            else if(response.status === 500){
                setErrorSnackbarOpen(true);
           setSnackbarErrorMessage(response.data.message)
            }
            else{
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage('Some error occured, please try again later');
            }
       
    
   
    }catch (error) {
        console.error("Error fetching monthly data:", error);
        }
    };
    return (
        <div>
  <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        severity="success"
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        sx={{ marginTop: '2.9%', marginRight: '7%' }}
      >
        <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        severity="error"
        open={errorSnackbarOpen}
        autoHideDuration={2000}
        sx={{ marginTop: '2.9%', marginRight: '7%' }}
        onClose={() => setErrorSnackbarOpen(false)}
      >
        <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
      </Snackbar>
  
       
      <div className="p-4" style={{ display: 'grid',gridTemplateColumns: '1fr 0.4fr',gridTemplateRows: '0fr 0fr', gap: '10px'}}>
  {/* LEFT: Vendor Wise Monthly Compliance Section */}
  <div className="d-grid" style={{border:'1px solid lightgray'}}>
  <div className="p-3 bg-dark text-light">
      <h6>Vendor Wise Monthly Compliance</h6>
    </div>
  <div className="d-flex">
    <div className="d-grid p-3">
      {/* Dropdowns */}
      <select className='text-dark mb-2' value={selectedClient} onChange={handleClientChange}
        style={{ width: '250px', height: '40px', border: '1px solid lightgray', cursor: 'pointer' }}>
        <option value="" disabled>Select Establishment</option>
        {clients?.length > 0 && clients.map(client => (
          <option key={client.companyId} value={client.companyId}>
            {client.clientName}, {client.stateId}
          </option>
        ))}
      </select>

      <select value={selectedVendor} onChange={handleVendorChange}
        className="mb-2" style={{ width: '250px', height: '40px', border: '1px solid lightgray', cursor: 'pointer' }}>
        <option value="" disabled>Select Vendor</option>
        {vendorOptions.map(vendor => (
          <option key={vendor.vendorId} value={vendor.vendorId}>
            {vendor.vendorCompanyName}, {vendor.vendorStateId}
          </option>
        ))}
      </select>

      <select value={selectedYear || ''} onChange={handleYearChange}
        className="mb-2" style={{ height: '40px', border: '1px solid lightgray', cursor: 'pointer' }}>
        <option value="" disabled>Select Year</option>
        {years.map(year => (
          <option key={year} value={year}>{year}</option>
        ))}
      </select>

      <select value={selectedQuarter} onChange={handleQuarterChange}
        style={{ height: '40px', border: '1px solid lightgray', cursor: 'pointer' }}>
        <option value="">All Months</option>
        <option value="Q1">Q1</option>
        <option value="Q2">Q2</option>
        <option value="Q3">Q3</option>
        <option value="Q4">Q4</option>
      </select>
    </div>

 
      {selectedClient && selectedVendor ? (
     <div style={{ width: '100%', maxWidth: '700px' }}>
    <Bar
   
    data={chartData}
    options={{
        responsive: true,
     
    plugins: {
        legend: { display:false},
        tooltip: { enabled: true,
            callbacks: {
                label: function (tooltipItem) {
                    const percentageValue = tooltipItem.raw;
                    const datasetLabel = tooltipItem.dataset.label; // Get the label of the dataset
                    let status = '';

                    // Determine the status based on the dataset label
                    if (datasetLabel === 'Accepted') {
                        status = 'Accepted';
                    } else if (datasetLabel === 'Rejected') {
                        status = 'Rejected';
                    } else if (datasetLabel === 'UnderReview') {
                        status = 'Under Review';
                    }

                    // Return the status with the percentage
                    return `${status}: ${percentageValue}%`;
                }
              }
         },
        datalabels: {
            display: false
    },
    },
   
    scales: {
        x: {
        title: { display: true },
        ticks: { color: 'gray' },
        borderColor: '#1c1c1c',
        borderWidth: 2,
        grid: { display: false },
       
       
   
        },
        y: {
        title: { display: true},
        min: 0,
        max: 100,
       
        ticks: {  stepSize: 15, color: 'gray', callback: value => value + '%' },
        borderColor: '#1c1c1c',
        borderWidth: 2,
        grid: { display: false }
        }
    }
    }}
/>
</div>


      ) 
      : (
        <div className="text-center p-5">
          Please select Establishment and Vendor to see graph
        </div>
      )}
   
 
  </div>
  </div>

  {/* RIGHT: Reports Section */}
  <div style={{border:'1px solid lightgray'}}>
    <div className="p-3 bg-dark text-light">
      <h6>Reports Section</h6>
    </div>

    <div className="p-3">
      {/* Report 1 */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="text-dark">Vendors Details</h6>
        <button className='text-danger' onClick={handleOpenDialog}>Click Here</button>
      </div>
      <hr />

      {/* Report 2 */}
      <div className="pt-3 d-flex justify-content-between align-items-center mb-3">
        <h6 className="text-dark">Vendors Monthly Compliance</h6>
        <button className='text-danger' onClick={handleOpenDialogComplianceReport}>Click Here</button>
      </div>
      <hr />

      {/* Report 3 */}
      <div className="pt-3 d-flex justify-content-between align-items-center">
        <h6 className="text-dark">Vendor Assessment Report</h6>
        <button className='text-danger' onClick={handleOpenDialogForAudit}>Click Here</button>
      </div>
    </div>
  </div>
</div>

                        
   
                         <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Export Contractor Data to Excel</span>
          
            <Button onClick={handleCloseDialog} color="error">
              Close
            </Button>
          </div>
        </DialogTitle>
        <select className='text-dark mx-4 mb-3'  value={selectedClientForReport} onChange={handleClientChangeForReport} style={{width:'300px',height:'30px',margin:'5px',border:'1px solid lightgray',maxWidth:'320px', cursor:'pointer'}}>
              <option value=""  disabled>Select Establishment</option>
              {clients && clients.length > 0 ? (
                clients.map(client => (
                  <option key={client.companyId} value={client.companyId}>
                      {client.clientName}, {client.stateId}
                  </option>
              ))):(
                <div>No Establishment Found!!</div>
              )}
          </select>
        
        <DialogContent>
            {isClientSelectedForReport? (
          <LcrReport/>
            ) : (
<>

</>
            )}
        </DialogContent>
      </Dialog>
                           
      <Dialog open={openDialogForAudit}  onClose={handleCloseDialogForAudit} maxWidth="md" fullWidth>
  <DialogTitle>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span>Assessment Report</span>
      <Button  onClick={handleCloseDialogForAudit} color="error">
        Close
      </Button>
    </div>
  </DialogTitle>

  <DialogContent>
    <div className="d-flex flex-wrap gap-2 mb-3">
      {/* Establishment Select */}
      <select
        className='text-dark'
        value={selectedClientForAudit}
        onChange={handleClientChangeForAudit}
        style={{ width: '250px', height: '40px', border: '1px solid lightgray', cursor: 'pointer' }}
      >
        <option value="" disabled>Select Establishment</option>
        {clients?.length > 0 && clients.map(client => (
          <option key={client.companyId} value={client.companyId}>
            {client.clientName}, {client.stateId}
          </option>
        ))}
      </select>

      {/* Vendor Select */}
      <select
        value={selectedVendorForAudit}
        onChange={handleVendorChangeForAudit}
        style={{ width: '250px', height: '40px', border: '1px solid lightgray', cursor: 'pointer' }}
      >
        <option value="" disabled>Select Vendor</option>
        {vendorOptions.map(vendor => (
          <option key={vendor.vendorId} value={vendor.vendorId}>
            {vendor.vendorCompanyName}, {vendor.vendorStateId}
          </option>
        ))}
      </select>

      {/* Month Select */}
      <select
        className="p-1"
        value={selectedMonthForAudit || ''}
        onChange={handleMonthChangeForAudit}
        style={{ border: '1px solid lightgray', height: '40px', cursor: 'pointer' }}
      >
        <option value="" disabled>Select Month</option>
        {months.map((month) => (
          <option key={month.value} value={month.value}>
            {month.name}
          </option>
        ))}
      </select>

      {/* Year Select */}
      <select
        className="p-1 text-dark"
        value={selectedYearForAudit || ''}
        onChange={handleYearChangeForAudit}
        style={{ border: '1px solid lightgray', height: '40px', cursor: 'pointer' }}
      >
        <option value="" disabled>Select Year</option>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>

      {/* Button */}
      <button className="btn btn-sm btn-danger" onClick={handleShow}>
        <span className="text-white">View Report</span>
      </button>
    </div>

   
  </DialogContent>
</Dialog>
{showModal &&  (
  <MonthlyReport
    showModal={showModal}
    onClose={handleClose}
    selectedMonth={selectedMonthForAudit}
    selectedYear={selectedYearForAudit}
  />
)}

      
      <Dialog open={openDialogComplianceReport} onClose={handleCloseDialogComplianceReport} maxWidth="md" fullWidth>
        <DialogTitle>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Export Contractor Data to Excel</span>
            <Button onClick={handleCloseDialogComplianceReport} color="error">
              Close
            </Button>
          </div>
        </DialogTitle>
        <div className="d-flex mx-4 mb-3">
        <select
        className='text-dark'
        value={selectedClientForComplianceReport}
        onChange={handleClientChangeForComplianceReport}
        style={{ width: '250px', height: '40px', border: '1px solid lightgray', cursor: 'pointer' }}
      >
        <option value="" disabled>Select Establishment</option>
        {clients?.length > 0 && clients.map(client => (
          <option key={client.companyId} value={client.companyId}>
            {client.clientName}, {client.stateId}
          </option>
        ))}
      </select>
            <select
                className="p-1 mx-2"
                value={selectedMonth || ''}
                onChange={handleMonthChange}
                style={{ border: '1px solid lightgray',cursor: 'pointer' }}
            >
                <option value="" disabled>Select Month</option>
                {months.map((month) => (
                    <option key={month.value} value={month.value}>
                        {month.name}
                    </option>
                ))}
            </select>

            <select
                className="p-1 text-dark mx-2"
                value={selectedYearForReport || ''}
                onChange={handleYearChanges}
                style={{ border: '1px solid lightgray', cursor: 'pointer' }}
            >
                <option value="" disabled>Select Year</option>
                {years.map((year) => (
                    <option key={year} value={year}>
                        {year}
                    </option>
                ))}
            </select>
        </div>
        <DialogContent>
            {selectedMonth && selectedYearForReport ? (
        <MonthlyComplianceReport month={selectedMonth} year={selectedYearForReport}/>
            ) : (
              <>
              </>
            )}
        </DialogContent>
        
      </Dialog> 
                           
        </div>

    )

}

export default MonthlyCompliance

